import { createClient } from "@supabase/supabase-js";
import { supabasePublishableKey, supabaseUrl } from "@/config";

// createClient throws on an empty key, which would blank the whole app at
// import; null lets the login page report the missing configuration.
export const supabase = supabasePublishableKey
  ? createClient(supabaseUrl, supabasePublishableKey)
  : null;
